import React, { useState, useEffect, useRef, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import questions from "../QA/Test8_q_a";
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test8.css";
import "../../../css/examplequestion.css";

const Test8 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [istest8Started, setIstest8Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score8 = useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 90;

  const exampleQuestions = [
    {
      wordA: "1.こだわる",
      wordB: "2.わかる",
      wordC: "3.理解する",
      wordD: "4.計画する",
      answer: [2, 3],
    },
    {
      wordA: "1.すぐれた",
      wordB: "2.やせた",
      wordC: "3.忠実な",
      wordD: "4.劣った",
      answer: [1, 4],
    },
  ];

  useEffect(() => {
    const test8Status = localStorage.getItem("test8Status");
    if (examStatus === "検査中" && test8Status === "started") {
      localStorage.setItem("test8Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;

    questions.forEach((question, index) => {
      const userAnswer1 = parseInt(inputValues[index]?.choice1, 10);
      const userAnswer2 = parseInt(inputValues[index]?.choice2, 10);
      if (
        question.answer.includes(userAnswer1) &&
        question.answer.includes(userAnswer2) &&
        userAnswer1 !== userAnswer2
      ) {
        calculatedScore += 1;
      }
    });

    score8.current = calculatedScore;
    localStorage.setItem("score8", calculatedScore);

    const normalizedScore = scoreTable.scoreTable8[String(calculatedScore)] ?? 0;
    const currentVScore = parseInt(localStorage.getItem("V_score"), 10) || 0;
    localStorage.setItem("V_score", currentVScore + normalizedScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← 次へ
  }, [inputValues, scoreTable.scoreTable8, onNext]);

  const handleStartTest = () => {
    setIstest8Started(true);
    localStorage.setItem("test8Status", "started");
  };

  const initialOptions = ["-", "1", "2", "3", "4"];

  const handleInputChange = (index, field, value) => {
    setInputValues((prevValues) => {
      const newValues = { ...prevValues };
      if (!newValues[index]) {
        newValues[index] = { choice1: "", choice2: "" };
      }
      newValues[index][field] = value;

      if (
        newValues[index].choice1 !== "" &&
        newValues[index].choice2 !== "" &&
        currentQuestionIndex === index
      ) {
        setCurrentQuestionIndex(index + 1);
      }

      return newValues;
    });
  };

  const getOptions = () => initialOptions;

  if (!istest8Started) {
    return (
      <div className="test8-container">
        <h1>検査6 - やり方の説明</h1>
        <p>
          各問題で4つの単語を比較し、同じ意味か、反対の意味を持つ2つの言葉を見つけ出し、<br />
          リストボックスから番号を選択してください。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <div className="example-questions">
            {exampleQuestions.map((ex, idx) => (
              <div key={idx} className="test8-example-question">
                <span className="test8-word">{ex.wordA}</span>
                <span className="test8-word">{ex.wordB}</span>
                <span className="test8-word">{ex.wordC}</span>
                <span className="test8-word">{ex.wordD}</span>
                <p>解答例: {ex.answer.join("と")}</p>
              </div>
            ))}
          </div>
        </div>
        <p>※「わかる」と「理解する」が同じ意味、「すぐれた」と「劣った」が反対の意味の言葉です。</p>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  const renderedQuestions = (
    <div className="test8-container">
      {questions.slice(0, currentQuestionIndex + 1).map((question, index) => (
        <div key={index} className="test8-question">
          <p>問題 {index + 1}</p>
          <div>
            <span className="test8-word">{question.wordA}</span>
            <span className="test8-word">{question.wordB}</span>
            <span className="test8-word">{question.wordC}</span>
            <span className="test8-word">{question.wordD}</span>
          </div>
          <div className="test8-inputs">
            <label>
              <select
                id={`question-${index}-choice1`}
                value={inputValues[index]?.choice1 || "-"}
                onChange={(e) => handleInputChange(index, "choice1", e.target.value)}
              >
                {getOptions().map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </label>
            <span> と </span>
            <label>
              <select
                id={`question-${index}-choice2`}
                value={inputValues[index]?.choice2 || "-"}
                onChange={(e) => handleInputChange(index, "choice2", e.target.value)}
              >
                {getOptions().map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <ZoomControls>
      <TestContainer
        title="検査6"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test8);
